import { render } from "./AssistantIcon.vue?vue&type=template&id=2bec6b34&scoped=true"
import script from "./AssistantIcon.vue?vue&type=script&lang=js"
export * from "./AssistantIcon.vue?vue&type=script&lang=js"

import "./AssistantIcon.vue?vue&type=style&index=0&id=2bec6b34&lang=less&scoped=true"

import exportComponent from "../../../../../vue3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bec6b34"],['__file',"js/components/shared/ChatWidget/ChatAssistant/AssistantIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2bec6b34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2bec6b34', __exports__)) {
    api.reload('2bec6b34', __exports__)
  }
  
  module.hot.accept("./AssistantIcon.vue?vue&type=template&id=2bec6b34&scoped=true", () => {
    api.rerender('2bec6b34', render)
  })

}


export default __exports__